<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-container>

<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
      <mat-card-title>Firmas Solicitadas</mat-card-title>
    </mat-card-header-->
    <mat-card-content>

    <div id="fieldsContainer">
        <mat-accordion class="iconTitle" multi>
            <mat-expansion-panel #advancedPanel >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon>find_in_page</mat-icon>Busqueda Avanzada
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div id="container" class="formControl">
					<div class="control">
						<mat-form-field class="imput-full-width">
						<mat-label>Folio</mat-label>
						<input type="text" matInput name="filterSignatures.f" [(ngModel)]="filterSignatures.f">
						</mat-form-field>
					</div>
					<div class="control">
						<mat-form-field class="controlWidth">
							<mat-label>Nombre</mat-label>
							<input matInput type="text" name="filterSignatures.n" [(ngModel)]="filterSignatures.n">
						</mat-form-field>
					</div>
					<div class="control">
						<mat-form-field class="controlWidth">
							<mat-label>Apellido Paterno</mat-label>
							<input matInput type="text" name="filterSignatures.ps" [(ngModel)]="filterSignatures.ps">
						</mat-form-field>
					</div>
					<div class="control">
						<mat-form-field class="controlWidth">
							<mat-label>Apellido Materno</mat-label>
							<input matInput type="text" name="filterSignatures.ms" [(ngModel)]="filterSignatures.ms">
						</mat-form-field>
					</div>
					<div class="control">
						<mat-form-field class="controlWidth">
						<mat-label>Division</mat-label>
						<mat-select [(ngModel)]="filterSignatures.d" name="filterSignatures.d">
							<mat-option [value]="-1">Todas las areas</mat-option>
							@for (division of divisions; track division.id) {
							<mat-option [value]="division.id">{{ division.description }}</mat-option>
							}
						</mat-select>
						</mat-form-field>
					</div>
					<div class="control">
						<mat-form-field class="controlWidth">
						<mat-label>Area</mat-label>
						<mat-select [(ngModel)]="filterSignatures.a" name="filterSignatures.a">
							<mat-option [value]="-1">Todas las divisiones</mat-option>
							@for (area of areas ; track area.id) {
							<mat-option [value]="area.id">{{ area.description }}</mat-option>
							}
						</mat-select>
						</mat-form-field>
					</div>
					<div class="control">
						<mat-form-field class="controlWidth">
						<mat-label>Estado</mat-label>
						<mat-select  name="filterSignatures.status" [(ngModel)]="filterSignatures.status">
							<mat-option value="ALL">Todos</mat-option>
							<mat-option value="SOL">Solicitada</mat-option>
							<mat-option value="AUT">Autorizada</mat-option>
							<mat-option value="RECH">Rechazada</mat-option>
							<mat-option value="REC">Registrada</mat-option>
						</mat-select>
						</mat-form-field>
					</div>
					<div class="control">
						<mat-form-field class="controlWidth">
						<mat-label>Activo</mat-label>
						<mat-select  name="filterSignatures.ac" [(ngModel)]="filterSignatures.ac">
							<mat-option value="-1">Todos</mat-option>
							<mat-option value="1">Activas</mat-option>
							<mat-option value="0">Inactivas</mat-option>
						</mat-select>
						</mat-form-field>
					</div>
				</div>
				<div id="buttonContainer">
					<button mat-flat-button class="button" (click)="searchSignaturesPaginatorAS()">
						<mat-icon>search</mat-icon>Consultar
					</button>
				</div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
    <br>
    <div id="tableContainer">
        <app-table #requestedignaturesTable  
            (paginatorEvent)="paginatorEvent($event)"
            (editEvent)="editEvent($event)"
            [tableModel]="tableModel">
        </app-table>
    </div>
    <br>

</mat-card-content>
<mat-card-footer class="general-wf-card-footer">
</mat-card-footer>
</mat-card>